import { render, staticRenderFns } from "./Medical.vue?vue&type=template&id=efb24dca&scoped=true"
import script from "./Medical.vue?vue&type=script&lang=js"
export * from "./Medical.vue?vue&type=script&lang=js"
import style0 from "./Medical.vue?vue&type=style&index=0&id=efb24dca&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb24dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efb24dca')) {
      api.createRecord('efb24dca', component.options)
    } else {
      api.reload('efb24dca', component.options)
    }
    module.hot.accept("./Medical.vue?vue&type=template&id=efb24dca&scoped=true", function () {
      api.rerender('efb24dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/Medical.vue"
export default component.exports